const common = {
  BASE_URL: 'https://food-boutique.b.goit.study/api',
  LOCAL_CART_KEY: 'cart',
  LOCAL_QUERY_KEY: 'query',
  LOCAL_SORT: 'sort',
  INIT_QUERY: { keyword: null, category: null, page: 1, limit: 6 },
  PAGES: 'pages',
  ORDER: 'order',

  NUMBER_OF_DISCOUNT: 2,
};

export { common };
